import type { FC } from "preact/compat";
import { Outlet } from "react-router-dom";
import ACCESS from "~/core/access";
import { me } from "~/core/store";
import { useAccessCheck, useBreakpoint } from "~/hooks";
import { FloatingMenu, FloatingTabs } from "~/organisms";
import AssignmentIcon from "@material-design-icons/svg/outlined/assignment.svg";
import ReceiptIcon from "@material-design-icons/svg/outlined/receipt_long.svg";
import ScheduleIcon from "@material-design-icons/svg/outlined/schedule.svg";
import TaskAltIcon from "@material-design-icons/svg/outlined/task_alt.svg";

const getTabs = () => [
    {
        name: "Time",
        link: me("admin/time"),
        icon: ScheduleIcon,
        access: ACCESS.adminTime,
    },
    {
        name: "Approval",
        link: me("admin/approval"),
        icon: TaskAltIcon,
        access: ACCESS.adminApproval,
        hidden: true,
    },
    {
        name: "Expenses",
        link: me("admin/expenses"),
        icon: ReceiptIcon,
        access: ACCESS.adminExpenses,
    },
    {
        name: "Tasks",
        link: me("admin/tasks"),
        icon: AssignmentIcon,
        access: ACCESS.adminTasks,
        hidden: true,
    },
];

const Admin: FC = () => {
    const { check } = useAccessCheck();
    const tabs = getTabs();
    const finalTabs = tabs
        .map((tab) => ({ ...tab, disabled: !check(tab.access) }))
        .filter((tab) => !tab.hidden || !tab.disabled);
    const bpMd = useBreakpoint("md");

    if (!bpMd.value) {
        return <Outlet />;
    }

    return (
        <div className="w-full h-full flex flex-col">
            {finalTabs.length > 1 && (
                <FloatingMenu
                    id="admin"
                    items={finalTabs}
                    defaultPosition={{
                        horizontal: false,
                        hidden: false,
                        left: "4px",
                        top: "calc(50vh - 26px)", // @TODO: document how to calculate this
                    }}
                />
            )}
            <FloatingTabs id="admin" items={finalTabs} />
            <Outlet />
        </div>
    );
};

export default Admin;
